
import React, { useState } from "react";
import {
    Box,
    Typography,
    Toolbar,
    InputAdornment,
    IconButton,
    TextField,
    Tooltip
} from "@mui/material";
import {ContainerClasses} from '../../themes/containerClasses'
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp'
import MenuIcon from "@mui/icons-material/Menu";
import AccountCircle from "@mui/icons-material/AccountCircle";
import {useTheme} from '@mui/material/styles';


export const SearchFieldComponent: React.FC<{
  searchText: string,
  setSearchText: (thisSearchText: string) =>  void,
  clearSearchText: () =>  void,
  onDatabaseSearch?: () => void
}> = ( {
  searchText,
  setSearchText,
  clearSearchText,
  onDatabaseSearch
}) => {

  const styles = ContainerClasses();

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    if(onDatabaseSearch !== undefined) onDatabaseSearch()
  }

  const searchFieldContainer = {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  }

  return (
    <form onSubmit={handleSubmit}>
      <TextField
        size="small"
        label="Search"
        variant="filled"
        InputProps={{
          disableUnderline: true,
          endAdornment: searchText ? (
            <InputAdornment position="end">
              {onDatabaseSearch !== null && onDatabaseSearch !== undefined &&
                <Tooltip title = "Search full database">
                  <IconButton size="small" type="submit">
                    <ArrowCircleUpIcon />
                  </IconButton>
                </Tooltip>
              }
              <IconButton size="small" onClick={() => clearSearchText()}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ) : (
            <InputAdornment position="end">
              <SearchIcon />
              <IconButton size="small" onClick={() => clearSearchText()}>
                <ClearIcon />
              </IconButton>
            </InputAdornment>
          ),
        }}
        value={searchText}
        onChange={(event) => setSearchText(event.target.value)}
      />
      </form>
);
};
